import {useMemo} from 'react';
import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';
import {useGlobals} from '../../../providers/globalPropsProvider';
import stylesParams from '../../../../components/ProductPage/stylesParams';

type TranslationFunction = (key: string) => string;

export function useStickyButtonText(t: TranslationFunction, isBuyNow: boolean): string {
  const {currentPrice, labelOverrides, addToCartState, isUserInputsValid, styles} = useGlobals();
  const shouldShowPrice = styles.get(stylesParams.productPage_productPrice);

  return useMemo(() => {
    const isPreOrder = addToCartState === AddToCartState.PRE_ORDER;

    let baseText: string;
    switch (true) {
      case isBuyNow && isPreOrder:
        baseText = labelOverrides?.cta?.buyNow || t('productPage.preOrderNow.button');
        break;
      case isBuyNow:
        baseText = labelOverrides?.cta?.buyNow || t('BUY_NOW_BUTTON');
        break;
      case isPreOrder:
        baseText = labelOverrides?.cta?.addToCart || t('productPage.preOrder.button');
        break;
      default:
        baseText = labelOverrides?.cta?.addToCart || t('ADD_TO_CART_BUTTON');
        break;
    }

    return shouldShowPrice && isUserInputsValid && currentPrice?.formattedActualPrice
      ? `${baseText} - ${currentPrice.formattedActualPrice}`
      : baseText;
  }, [
    addToCartState,
    t,
    isBuyNow,
    labelOverrides?.cta?.addToCart,
    labelOverrides?.cta?.buyNow,
    isUserInputsValid,
    currentPrice?.formattedActualPrice,
    shouldShowPrice,
  ]);
}
